import { render, staticRenderFns } from "./WhActivityDetail.vue?vue&type=template&id=05209b5a&scoped=true&"
import script from "./WhActivityDetail.vue?vue&type=script&lang=js&"
export * from "./WhActivityDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05209b5a",
  null
  
)

export default component.exports